<template>
  <div :class="{ 'summar-box-2': isUi2 }">
    <m-demo-breakdown-report />
    <div class="card card-margin">
      <b-container>
        <b-row v-if="!isUi2 && isRadius">
          <b-col class="address">
            <h3 class="list-name-container"> Address Information</h3>
            <b-link class="link" @click="goGeo" style="display: none;">Edit</b-link>
          </b-col>
        </b-row>
        <div v-if="isRadius">
          <template v-for="item in orderaddress">
            <b-row class="padding-style">
              <b-col md="6"
                ><b-link @click="mapPanto(item)">{{
                  item.AddressName
                }}</b-link></b-col>
              <b-col md="6" class="radius-mile">Radius: {{ item.Radius }} mile(s)</b-col>
            </b-row>
          </template>
        </div>
        <b-row v-if="!isUi2">
          <b-col>
            <h3 class="list-name-container">Available Records by Area</h3>
            <!-- <b-link class="link"  @click="goGeo">Edit</b-link> -->
          </b-col>
        </b-row>
        <!-- <div v-if="isZipMap">
              <b-row style="margin-top: 16px">
                <b-col>
                  <m-map map-id="summaryZipMap" @load="createZipMap"></m-map>
                </b-col>
              </b-row>
            </div>
            <div v-if="!isMap && order.GeoType === 7">
              <b-row style="margin-bottom: 16px">
                <b-col>
                  <div id="maps" class="circle">
                    <m-map map-id="summarymap" @load="createMap"></m-map>
                  </div>
                </b-col>
              </b-row>
            </div> -->
        <div v-if="!isMap && order.GeoType !== 7">
          <table width="100%">
            <tr>
              <th width="20%">Area(s)</th>
              <th width="30%" style="text-align: center">Quantity Available</th>
              <th width="20%" style="text-align: right">Quantity Selected</th>
            </tr>
            <template v-if="isShowDetail">
              <template v-for="(item, index) of geoItems">
                <tr
                  v-for="(subItem, subIndex) of item.OrderGeoDetails"
                  class="sm-row"
                >
                  <td class="list-name-container">
                    <p class="table-display">
                      {{ getDetailDesc(item, subItem) }}
                    </p>
                  </td>
                  <td>
                    <p class="table-available">
                      {{ subItem.AvailableQty | numberFormat("", 0) }}
                    </p>
                  </td>
                  <td>
                    <b-input
                      :value="subItem.DesiredQty"
                      :formatter="formatNumber"
                      class="desired-input"
                      @change.native="
                        changeGeoDetailCount(
                          index,
                          subIndex,
                          $event,
                          subItem.AvailableQty
                        )
                      "
                      :disabled="item.AvailableQty === 0"
                      :max="subItem.AvailableQty"
                    ></b-input>
                  </td>
                </tr>
              </template>
            </template>
            <template v-else>
              <tr
                v-for="(item, index) of geoItems"
                :key="item.GeoKeyCode"
                class="sm-row"
              >
                <td>
                  <p class="table-display">
                    {{ getGeoDesc(item) }}
                  </p>
                </td>
                <td>
                  <p class="table-available">
                    {{ item.AvailableQty | numberFormat("", 0) }}
                  </p>
                </td>
                <td>
                  <b-input
                    :value="item.DesiredQty"
                    :formatter="formatNumber"
                    class="desired-input"
                    @input.native="
                      updateDesiredQty(index, $event, item.AvailableQty)
                    "
                    :disabled="order.ListType === 50 || item.AvailableQty === 0"
                    :max="item.AvailableQty"
                  ></b-input>
                </td>
              </tr>
            </template>
            <tr class="separator">
              <td colspan="3">
                <hr style="border: 1px solid" />
              </td>
            </tr>
            <tr v-if="this.order.ListType !== 50">
              <th class="table-display">Total</th>
              <td>
                <p class="table-available">
                  {{ order.TotalAvailableQty| numberFormat("", 0) }}
                </p>
              </td>
              <td>
                <b-input
                  :value="order.TotalDesiredQty"
                  class="desired-input total-desired"
                  @change.native="changeTotalCount($event)"
                  :max="order.TotalAvailableQty"
                />
              </td>
            </tr>
          </table>
          <b-row v-if="this.order.ListType === 50" class="summary-box">
            <b-col>
              <strong>You may modify quantities by using the grid below:</strong
              ><br />
              To select all Homes, Apartments or Businesses, click on the
              checkmark next to the quantities listed in the TOTAL row. To view
              and select by carrier route, click on the view/hide icon (/) next
              to each area. You will also have an option to enter a custom
              quantity per carrier route. To do this, enter a valid quantity and
              press the 'Tab' key.
              <br /><strong
                >Note: Reducing the quantity selected in a given area may
                disqualify you from receiving the Saturation mail postage
                discount.</strong
              >
            </b-col>
          </b-row>
        </div>
        <div v-if="isMap">
          <!-- <b-row style="margin-bottom: 16px">
                <b-col>
                  <div id="maps" class="circle">
                    <m-map map-id="summarymap" @load="createMap"></m-map>
                  </div>
                </b-col>
              </b-row> -->
          <b-row class="sm-row">
            <b-col lg="2" class="title sm-col">
              <h5>List Quantity</h5>
            </b-col>
            <b-col
              lg="2"
              class="sm-col"
              v-if="
                this.$store.state.order.ListType !== 50 &&
                geoType !== 16 &&
                geoType !== 13
              "
            >
              <b-link @click="tigger()">{{ btntext }}</b-link
              ><br />
              <b-link @click="seeReport"> See Report</b-link>
            </b-col>
            <b-col lg="3" class="sm-col">
              <h5>Qty Available</h5>
            </b-col>
            <b-col lg="2" class="sm-col">
              <h5>Distance</h5>
            </b-col>
            <b-col lg="3" class="sm-col">
              <h5 style="text-align: right">Qty Desired</h5>
            </b-col>
          </b-row>
          <b-row v-show="isShow || geoType === 16">
            <b-col>
              <template
                v-if="
                  geoItems.length > 0 &&
                  geoItems[0].OrderGeoDetails &&
                  geoType !== 13
                "
              >
                <b-row
                  v-for="(item, index) of geoItems"
                  :key="item.GeoKeyCode"
                  class="sm-row"
                >
                  <b-col sm="1" class="sm-col">
                    <b-check
                      checked="true"
                      @change="updateCheckDesiredQty(index, $event)"
                    ></b-check>
                  </b-col>
                  <b-col sm="3" class="sm-col">
                    {{ getGeoDesc(item) }}
                  </b-col>
                  <b-col sm="3" class="sm-col">
                    {{ item.AvailableQty | numberFormat("", 0) }}
                  </b-col>
                  <b-col sm="2" class="sm-col">
                    {{ item.DistanceDuration }}
                  </b-col>
                  <b-col sm="3" class="sm-col">
                    <b-input
                      :value="getDesiredQty(item.OrderGeoDetails[0])"
                      :formatter="formatNumber"
                      class="desired-input"
                      @change.native="
                        updateMapDesiredQty(index, $event, item.AvailableQty)
                      "
                      :disabled="item.AvailableQty === 0"
                      :max="item.AvailableQty"
                    ></b-input>
                  </b-col>
                </b-row>
              </template>
              <template v-else>
                <template v-for="(item, index) of geoItems">
                  <b-row
                    v-for="(subItem, subIndex) of item.OrderGeoDetails"
                    :key="item.GeoKeyCode"
                    class="sm-row"
                  >
                    <b-col>
                      <p>{{ getDetailDesc(item, subItem) }}</p>
                    </b-col>
                    <v-col>
                      <p>
                        {{ subItem.AvailableQty | numberFormat("", 0) }}
                      </p>
                    </v-col>
                    <b-col>
                      <p>{{ subItem.DistanceDuration }}</p>
                    </b-col>
                    <b-col>
                      <b-input
                        :value="subItem.DesiredQty"
                        :formatter="formatNumber"
                        class="desired-input"
                        @change.native="
                          changeGeoDetailCount(
                            index,
                            subIndex,
                            $event,
                            subItem.AvailableQty
                          )
                        "
                        :disabled="item.AvailableQty === 0"
                        :max="subItem.AvailableQty"
                      ></b-input>
                    </b-col>
                  </b-row>
                </template>
              </template>
            </b-col>
          </b-row>
          <b-row v-show="!isShow || geoType === 16" class="sm-row">
            <b-col sm="4" class="sm-col"><h5>Total:</h5></b-col>
            <b-col sm="3" class="sm-col">{{
              order.TotalAvailableQty | numberFormat("", 0)
            }}</b-col>
            <b-col sm="2" class="sm-col"></b-col>
            <b-col sm="3" class="sm-col">
              <b-input
                v-model="totalDesiredQty"
                :formatter="formatNumber"
                class="desired-input total-desired"
                @change.native="
                  updateTotalDesiredQty($event, order.TotalAvailableQty)
                "
                :max="order.TotalAvailableQty"
              ></b-input>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import priceHelp from "@/assets/priceHelp";
import utils from "@/assets/utils/index";
import MMap from "@/components/geo/MMap";
import MDemoBreakdownReport from "@/components/summary/MDemoBreakdownReport";
import notificaton from "@/components/common/notification";
import _ from "lodash";

export default {
  components: {
    MMap,
    MDemoBreakdownReport,
  },
  props: {
    isUi2: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.selectGeos = this.$store.state.order.OrderGeos;
    setTimeout(() => {
      this.selectGeos = this.$store.state.order.OrderGeos;
    }, 1000);
  },
  data() {
    return {
      selectGeos: {},
      d: "",
      isShow: false,
      map: null,
      zipMap: null,
      graphics: [],
      polygon: null,
      tempAddress: [],
      showPromotionSuccess: true,
      promotionCodeIsNaN: false,
      showErrorPromotion: false,
      promotionCodeInput: "",
      promotion: { PromotionName: "text" },
    };
  },
  computed: {
    order() {
      return this.$store.state.order;
    },
    geoType() {
      return this.order.GeoType;
    },
    geoItems() {
      return this.$store.getters["order/geoItems"];
    },
    isMap() {
      return (
        (this.geoType === 12 ||
          this.geoType === 13 ||
          this.geoType === 7 ||
          this.geoType === 16) &&
        this.order.ListType !== 50
      );
    },
    isZipMap() {
      if (
        this.$store.state.order.GeoType === 5 &&
        this.$store.state.order.ZipType === 0
      ) {
        if (this.$store.state.order.OrderGeos.length >= 15) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    btntext() {
      return this.isShow ? "Hide Details" : "Show Details";
    },
    currentGeoType() {
      return this.$store.getters["order/currentGeoType"];
    },
    totalDesiredQty: {
      get() {
        return this.$store.getters["order/totalDesiredQty"];
      },
      set() {},
    },
    orderaddress() {
      if (this.geoType === 16 || this.geoType === 7) {
        return _.filter(this.$store.getters["order/orderaddress"], (item) => {
          return item.AddrUsageType === 2;
        });
      } else {
        return this.$store.getters["order/orderaddress"];
      }
    },
    isRadius() {
      return this.geoType === 16 || this.geoType === 7;
    },
    isShowDetail() {
      let result =
        ((this.order.ListType === 130 || this.order.ListType === 140) &&
          (this.geoType === 5 || this.geoType === 18)) ||
        this.geoType === 11;
      return result;
    },
    promotionCode: {
      get() {
        this.promotionCodeInput = this.order.PromoCode || "";
        return this.order.PromoCode || "";
      },
      set(val) {
        this.promotionCodeInput = val;
      },
    },
    showPromotion() {
      return true;
      // return this.$store.getters['site/showPromotion']
    },
  },
  activated() {},
  methods: {
    updateDesiredQty(index, e, max) {
      if (e.target.value === "") {
        return false;
      }
      let desiredQty = this.formatInter(e, max);

      this.$store.commit("order/updateDesiredQty", {
        index: index,
        qty: desiredQty,
      });
      this.$store.dispatch("order/calculatePrice");
    },
    updateTotalDesiredQty(e, max) {
      if (e.target.value === "") {
        return false;
      }
      let desiredQty = this.formatInter(e, max);
      if (desiredQty > this.order.TotalAvailableQty) {
        desiredQty = this.order.TotalAvailableQty;
      }
      if (this.order.OrderGeos.length === 0) {
        this.$http
          .post("PlaceOrder.aspx/RedistributeOrderTotalQty", {
            totalDesiredQty: desiredQty,
          })
          .then((resp) => {
            if (resp.body.d.ResultFlag) {
              this.$store.commit("order/saveKey", [
                "TotalDesiredQty",
                desiredQty,
              ]);
              this.$store.dispatch("order/calculatePrice");
            }
          });
      } else {
        this.$store.dispatch("order/changeTotalCount", {
          totalCount: desiredQty,
        });
      }
    },
    updateMapDesiredQty(index, e, max) {
      if (e.target.value === "") {
        return false;
      }
      let desiredQty = this.formatInter(e, max);
      // this.$http.post('PlaceOrder.aspx/UpdateDesiredQtyOfOrderGeoDetails', {
      //   DesiredQty: desiredQty,
      //   geoDetailsIndex: 0,
      //   geoIndex: index
      // }).then(
      //   resp => {
      //     if (resp.body.d.ResultFlag) {
      this.$store.commit("order/saveGeoDesiredQty", {
        index: index,
        val: desiredQty,
      });
      priceHelp.RecaculateTotalGeoQty(this.order, index);
      this.$store.dispatch("order/calculatePrice");
      //   }
      // })
    },
    updateCheckDesiredQty(index, e) {
      if (e) {
        this.$http
          .post("PlaceOrder.aspx/UpdateDesiredQtyOfOrderGeoDetails", {
            DesiredQty: this.geoItems[index].AvailableQty,
            geoDetailsIndex: 0,
            geoIndex: index,
          })
          .then((resp) => {
            if (resp.body.d.ResultFlag) {
              this.$store.commit("order/saveGeoDesiredQty", {
                index: index,
                val: this.geoItems[index].AvailableQty,
              });
              priceHelp.RecaculateTotalGeoQty(this.order, index);
              this.$store.dispatch("order/calculatePrice");
            }
          });
      } else {
        this.$http
          .post("PlaceOrder.aspx/UpdateDesiredQtyOfOrderGeoDetails", {
            DesiredQty: 0,
            geoDetailsIndex: 0,
            geoIndex: index,
          })
          .then((resp) => {
            if (resp.body.d.ResultFlag) {
              this.$store.commit("order/saveGeoDesiredQty", {
                index: index,
                val: 0,
              });
              priceHelp.RecaculateTotalGeoQty(this.order, index);
              this.$store.dispatch("order/calculatePrice");
            }
          });
      }
    },
    formatInter(e, max) {
      let val = e.target.value;
      console.log(val);
      console.log(max);
      let num = parseInt(val);
      if (val === "") {
      } else if (isNaN(num) || num < 0) {
        val = 0;
      } else if (num > max) {
        val = max;
      }
      if (val + "" !== e.target.value) {
        setTimeout(() => {
          e.target.value = val;
        }, 1);
      }
      return Number(val);
    },
    formatNumber(val) {
      let num = parseInt(val);
      if (val === "") {
        return val;
      }
      if (isNaN(num)) {
        return 0;
      } else if (num < 0) {
        return 0;
      } else {
        return num;
      }
    },
    goGeo() {
      if (this.currentGeoType.routeName) {
        this.$router.push({ name: "geo" });
      } else {
        let geoType = this.currentGeoType.name;
        if (this.currentGeoType.title === "Radius Around an Address") {
          geoType = "radius";
        }
        this.$router.push({ name: "geo-" + geoType });
      }
    },
    tigger() {
      if (this.isShow) {
        this.isShow = false;
      } else {
        if (this.geoItems.length > 0) {
          this.isShow = true;
          return;
        }
        this.$http
          .post("PlaceOrder.aspx/GetOrderGeos", {
            async: false,
          })
          .then((resp) => {
            if (resp.body.d.ResultFlag) {
              let geos = _.filter(resp.body.d.DataSource, (item) => {
                return item.AvailableQty > 0;
              });
              this.$store.commit("order/saveKey", ["OrderGeos", geos]);
              this.isShow = true;
            }
          });
      }
    },
    getGeoDesc(geo) {
      geo.OrderGeoDetails = geo.OrderGeoDetails || [];
      if (
        geo.OrderGeoDetails === null ||
        geo.OrderGeoDetails.length === 0 ||
        geo.GeoType === 4 ||
        geo.GeoType === 22 ||
        this.order.ListType === 50
      ) {
        return geo.GeoKeyDesc;
      } else {
        if (
          (geo.GeoType === 12 || geo.geoType === 16 || geo.GeoType === 13) &&
          geo.OrderGeoDetails[0].DetailCode !==
            geo.OrderGeoDetails[0].DetailDesc
        ) {
          return (
            geo.OrderGeoDetails[0].DetailCode +
            "," +
            geo.OrderGeoDetails[0].DetailDesc
          );
        } else {
          return geo.OrderGeoDetails[0].DetailDesc;
        }
      }
    },
    getDetailDesc(item, subItem) {
      if (subItem.DetailDesc !== subItem.DetailCode) {
        return subItem.DetailCode + "," + subItem.DetailDesc;
      } else {
        return item.CityName + "," + subItem.DetailDesc;
      }
    },
    createMap() {
      this.map = utils.maps["summarymap"];
      this.updateMap();
    },
    getDesiredQty(detail) {
      if (detail) {
        return detail.DesiredQty;
      }
      return 0;
    },
    createZipMap() {
      this.zipMap = utils.maps["summaryZipMap"];
      this.zipMap.addLayer();
      this.updateMap();
    },
    updateMap() {
      // Clear radius
      for (let item of this.graphics) {
        if (item.c) {
          item.c.setMap(null);
          item.m.setMap(null);
        }
      }

      // clear polygon
      if (this.polygon !== null) {
        this.polygon.setMap(null);
      }

      // draw circle
      if (this.order.GeoType === 16 || this.order.GeoType === 7) {
        this.graphics = this.map.initCircleDrawing(this.orderaddress, true);

        // draw polygon
      } else if (this.order.GeoType === 13) {
        let paths = [];
        let address = this.orderaddress[0];
        if (address.AddrSearchString !== null) {
          for (let path of address.AddrSearchString.split("|")) {
            paths.push({
              lat: Number(path.split(":")[1]),
              lng: Number(path.split(":")[0]),
            });
          }
          this.polygon = this.map.initPolygon(paths);
        }

        // draw closex
      } else if (this.order.GeoType === 12) {
        this.map.marker({
          lat: Number(this.orderaddress[0].Latitude),
          lng: Number(this.orderaddress[0].Longitude),
        });
        this.map.map.setCenter({
          lat: Number(this.orderaddress[0].Latitude),
          lng: Number(this.orderaddress[0].Longitude),
        });
        this.map.map.setZoom(12);

        // draw zip
      } else if (this.order.GeoType === 5) {
        this.zipMap.addLayer("ZIP", "", true);
        this.zipMap.updateZipBounders();
      }
    },
    seeReport() {
      this.$root.$emit("bv::show::modal", "seeReport");
    },
    changeGeoDetailCount(rowIndex, index, e, maxValue) {
      let desiredQty = this.formatInter(e, maxValue);
      this.$store.dispatch("order/changeZipGeoDetailCount", {
        rowIndex: rowIndex,
        index: index,
        count: desiredQty,
      });
    },
    changeTotalCount(e) {
      let totalCount = e.target.value;
      if (e.target.value < this.$store.state.site.MinQuantityOfOrder) {
        this.alertDesc =
          "The quantity that you entered is less than the minimum quantity of 20.";
        totalCount = this.$store.state.site.MinQuantityOfOrder;
        notificaton.notice(
          "warning",
          "The quantity that you entered is less than the minimum quantity of " +
            totalCount +
            ".",
          { title: "Count Number Error", onlyGroup: "CountNumberError" }
        );
      }
      this.$store.dispatch("order/changeTotalCount", {
        totalCount: totalCount,
      });
    },
    mapPanto(address) {
      this.map.map.setZoom(12);
      this.map.map.panTo({
        lat: Number(address.Latitude),
        lng: Number(address.Longitude),
      });
    },
    recalculate() {
      console.log(this.tempAddress);
      for (let item of this.tempAddress) {
        let searchstring =
          item.Address.Longitude +
          ":" +
          item.Address.Latitude +
          ":" +
          item.Radius +
          ":2";
        this.$store.commit("order/updateAddress", {
          Radius: item.Radius,
          AddrSearchString: searchstring,
          oldAddrSearchString: item.Address.AddrSearchString,
        });
        this.$store.commit("order/updateGeo", {
          AddressLine: searchstring,
          GeoKeyCode: searchstring,
          oldGeoKeyCode: item.Address.AddrSearchString,
        });
      }
      this.$store.dispatch("order/submitOrder");
      this.updateMap();
    },
    radiusChange(address, e) {
      let isExis = false;
      console.log(e);
      let radius = Number(e);
      for (let item of this.tempAddress) {
        if (item.Address.AddrSearchString === address.AddrSearchString) {
          item.Radius = radius;
          isExis = true;
        }
      }
      if (!isExis) {
        this.tempAddress.push({ Address: address, Radius: radius });
      }
    },
    promotionChange(e) {
      this.promotionCodeIsNaN = e.target.value === "";
    },
    applyPromotionCode() {
      if (this.promotionCodeInput === "") {
        this.promotionCodeIsNaN = true;
        return;
      }
      this.showErrorPromotion = false;
      this.$http
        .post("PlaceOrder.aspx/GetPromotion", {
          listtype: this.order.ListType,
          promotionCode: this.promotionCodeInput,
        })
        .then(
          (resp) => {
            this.$store.commit("summary/saveKey", [
              "Promotion",
              resp.body.d.DataSource,
            ]);

            if (resp.body.d.DataSource !== null) {
              this.$store.commit("order/saveKey", [
                "PromoCode",
                this.promotionCodeInput,
              ]);
              this.promotion = resp.body.d.DataSource;
            } else {
              this.showErrorPromotion = true;
              this.$store.commit("order/saveKey", ["PromoCode", ""]);
            }
            this.$store.dispatch("order/calculatePrice");
          },
          (resp) => {
            this.showErrorPromotion = true;
            this.promotionCodeInput = "";
            this.$store.commit("order/saveKey", [
              "PromoCode",
              this.promotionCodeInput,
            ]);
            this.$store.commit("summary/saveKey", ["Promotion", null]);

            // this.$store.dispatch('order/calculatePrice')
          }
        );
    },
  },
};
</script>

<style scoped lang="scss">
.title {
  display: flex;
  justify-content: space-between;
}

.title-text {
}

.desired-input {
  max-width: 200px;
  font-size: 1rem;
  padding: 0;
  text-align: right;
}

.text-deep {
  font-size: 12px;
}

.title {
  display: flex;
}

.text-deep {
  font-size: 12px;
}

.h5-t {
  font-size: 1em;
}

.link {
  margin-left: 16px;
  margin-top: 16px;
}

.td-broder {
  border: 1px solid rgb(204, 204, 204);
  padding: 1px;
  background-color: $color-background;
}

.td-broder-raduis {
  border: 1px solid rgb(204, 204, 204);
  padding: 1px;
}

.GeographyDetail span {
  font-weight: bold;
  font-size: 11px;
}

.GeographyDetail td {
  font-weight: bold;
  font-size: 11px;
  border-color: Black;
  border-width: 1px;
  border-style: solid;
  text-transform: uppercase;
}

.GeographyDetail {
  width: 100%;
  border-bottom-width: 1px;
  border-bottom-color: Black;
  border-bottom-style: solid;
}

.whitetext {
  color: #ffffff;
  font-size: 11px;
  font-weight: normal;
  line-height: 14px;
  border-style: solid;
  border-color: White;
  border-width: 1px;
  width: 220px;
}

.circle {
  width: 100%;
}

.sm-col {
  padding-right: 4px;
  padding-left: 4px;
}

.sm-row {
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 16px;
}

.total-desired {
  // padding-right: 13px;
}
.desired-input {
  padding-right: 8px;
}
.demo-block {
  border: 1px solid #ebebeb;
  border-radius: 5px;
  transition: 0.2s;
  width: 500px;
  margin-bottom: 10px;
  margin: 10px auto;
}
.list-name-container {
  margin-top: 16px;
  margin-left: 10px;
  font-weight: bold;
}
.center-align {
  text-align: center;
}
.demo-box {
  margin-left: 8px;
  margin-bottom: 0px;
  margin-top: 8px;
}
.card-margin {
  margin: 8px auto;
}
.table-display {
  display: flex;
  align-items: center;
  margin-top: 8px;
  margin-left: 8px;
}
.table-available {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
}
.padding-style {
  padding: 8px 8px 4px 8px;
}

.promot-text {
  font-size: 13px;
  color: $color-primary-light;
}

.promotion-form {
  display: flex;
}

.code-style {
  margin-bottom: 8px;
  margin-left: 16px;
  margin-right: 24px;
  width: 20rem;
}

.prop-btn{
  margin-bottom: 8px;
}
.promot-alter{
  margin: 0px 16px 8px 16px;
}
.address{
  display: flex;
  justify-content: space-between;
}
.radius-mile{
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/summary/MTargetArea.vue